import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { deepAssign, deepExtract } from 'helpers/deep';
import { HEADER_LAYOUT, RESULTS_LAYOUT } from '../Search.constants';
import { SearchVenue } from './SearchVenue';
export var SearchLayout = function SearchLayout() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, SearchLayout);

  var modeledData = _objectSpread({}, data);

  var venuePaths = [];

  if (config.layoutName === RESULTS_LAYOUT) {
    venuePaths = ['web_search_results_01.data.map_items', 'web_search_results_01.data.venue_tab_items'];
  } else if (config.layoutName === HEADER_LAYOUT) {
    venuePaths = ['nearby_venues.data'];
  } // Model venue paths


  venuePaths.forEach(function (path) {
    var value = deepExtract(path, modeledData, []).map(function (venue) {
      return new SearchVenue(venue, {
        distanceUnit: config.distanceUnit
      });
    });

    if (value.length) {
      deepAssign(path, modeledData, value);
    }
  });
  Object.assign(this, modeledData);
};